<template>
  <div class="app-head-container">
    <div class="app-head-center inner-container">
      <div class="left">
        <div class="mall hand" @click="$goMallPath('')">供应商采购</div>
        <div class="mall hand" @click="$goMallPath('bigfrastructIndex')">大基建采购</div>
        <!-- <div class="categories hand">
          <i></i>
          商品分类
          <div class="classification-shell-container">
            <div class="classification-center" v-for="item in categoryList" :key="item.key">
              <p :class="{blue: item.existence}" @click.stop="goProductList(item, item.title, item.key)">{{item.title}}</p>
              <ul v-for="childItem in item.children" :key="childItem.key">
                <li :class="{blue: childItem.existence}" @click.stop="goProductList(childItem, childItem.title, childItem.key)">{{childItem.title}}</li>
              </ul>
            </div>
          </div>
        </div> -->
        <!--<div class="go-center hand" @click="$goMallPath('purchaserCenter/accountInfo')">管理中心</div>-->
      </div>
      <div class="right">
        <div class="login-reg red" v-if="!acctName && !timerToGetAcctName">
          <!--<span @click="$goMallPath('login')" class="hand">请登录</span>-->
          <span @click="goLogin('login')" class="hand">请登录</span>
          <span class="mlr2">|</span>
          <span @click="$goMallPath('register')" class="hand">注册</span>
        </div>
        <div class="login-reg blue" v-else>
          <span>{{timerToGetAcctName || acctName}}</span>
        </div>
        <!-- <div class="info">
          客服电话：400-0609-008 （工作日上午8:30-11:30，下午13:00-17:30）
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  InterfaceService
} from '@/services/api'
import $ from 'jquery'
import { BASE_CONFIG } from '@/config/config'

export default {
  props: {
    current: {
      type: String,
      default: '' //这样可以指定默认的值
    },
    acctName: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      categoryList: '',
      timerToGetAcctName: '',
      timer: null,
      intervalNum: 0,
      categoryBaseBeans: [],
    }
  },
  watch: {
    acctName(newVal) {
      console.log(newVal);
    }
  },
  computed: {
  },
  methods: {
    goProductList(item, name, id) {
      if (!item.existence) return
      const url = BASE_CONFIG.ROOT_URL || ''

      if (id === '1000' || id === '10001' || id === '10002' || id === '100011' || id === '100021') {
        window.location = `${url}/#/threeNew?scrollTop=${(id === '10001' || id === '100011') ? 959 : (id === '10002' || id === '100021') ? 2080 : 0}`
        return
      }
      window.location = `${url}/#/productList?query=${JSON.stringify({ 'categoryId': id, 'categoryName': name })}`
    },

    goLogin() {
      this.intervalNum = 0;
      this.$goMallPath('login');
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.intervalNum <= 5 && !this.timerToGetAcctName) {
          this.getLoginFlg()
        } else {
          clearInterval(this.timer)
        }
      }, 5000)

    },
    getLoginFlg() {
      this.intervalNum++;
      InterfaceService.getLoginFlg(
        {},
        data => {
          let res = data.respData || {};
          if (data && data.respData && res.respCode === "0000") {
            this.timerToGetAcctName = data.respData.acctName || "";
          } else {
            // this.$removeRootScope("acctName")
            // localStorage.setItem("acctName","")
          }
        }, data => {
          // this.$removeRootScope("acctName")
          // localStorage.setItem("acctName","")

        }, () => {
          this.isLoading = true
        }, () => {
          this.isLoading = false
        })
    },


    getCategoryOfBidWinning() {
      return new Promise((resolve, reject) => {
        const categoryBaseBeans = JSON.parse(this.$getRootScope('categoryBaseBeans') || '[]') || []
        if (categoryBaseBeans.length) {
          this.categoryBaseBeans = categoryBaseBeans
          resolve(true)
          return
        }
        InterfaceService.getCategoryOfBidWinning({}, data => {
          if (data.respData && data.respData.respCode === "0000") {
            this.categoryBaseBeans = data.respData.categoryBaseBeans || []
            this.$setRootScope('categoryBaseBeans', JSON.stringify(data.respData.categoryBaseBeans))
          } else {
            this.$message.error(data.respData && data.respData.respMsg);
          }
          resolve(true)
        }, data => { reject(data) }, () => { }, () => { });
      })
    },

    /**
   * 查找已存在商品类目
   */
    findAlreadyExists(categoryBaseBeans, res) {
      categoryBaseBeans && categoryBaseBeans.forEach(f => {
        this.categoryInfosExternalCirculation(f.categoryId, res)
        if (f.children && f.children.length) {
          this.findAlreadyExists(f.children, res)
        }
      })
    },

    categoryInfosExternalCirculation(id, res) {
      res && res.some(s => {
        if (s.key == id) {
          return this.$set(s, 'existence', true)
        }
        if (s.children && s.children.length) {
          this.categoryInfosExternalCirculation(id, s.children)
        }
      })
    },

    async init() {
      try {
        await this.getCategoryOfBidWinning()
      } catch (error) {
        throw new TypeError('getCategoryOfBidWinning Error')
      }

      const config = this.$getConfig() || {}
      $.ajax({
        url: `${config.OSS_SERVICE_ADDRESS}/djc/statics/category/pd_category_info.json`, success: (result) => {
          result = typeof (result) === 'object' ? result : JSON.parse(result) || {}
          this.categoryList = result.children || []
          this.findAlreadyExists(this.categoryBaseBeans, this.categoryList)
          console.log(this.categoryList, 'categoryList');

        }
      })
    },
  },
  mounted() {
    this.init()
  },
  destroyed() {
    this.timer && clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.app-head-container {
  width: 100%;
  height: 34px;
  background: #eeeeee;
  display: flex;
  align-items: center;
  z-index: 4;
  position: relative;
  .red {
    color: #e60012;
  }
  .mlr2 {
    margin: 0 2px;
  }
  .app-head-center {
    display: flex;
    justify-content: space-between;
    color: #333;
    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.left {
        align-items: center;
      }
      &.right {
        .info {
          color: #393939;
          margin-left: 30px;
        }
      }
      & > div {
        &:first-child {
          margin-right: 12px;
        }
        &.categories {
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 10px;
          transition: all 0.3s linear;
          height: 33px;
          &:hover {
            background: #fff;
            .classification-shell-container {
              display: flex;
            }
          }
          i {
            background: url(../../assets/images/icon/sprite-icon.png) no-repeat -120px -17px;
            width: 14px;
            height: 14px;
            display: block;
            margin-right: 4px;
          }
          .classification-shell-container {
            background: #fff;
            position: absolute;
            top: 30px;
            left: 0;
            box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
            z-index: 3;
            width: 1036px;
            padding: 20px;
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
            display: none;
            .classification-center {
              width: 33%;
              p {
                font-size: 14px;
                color: #333;
                height: 52px;
                line-height: 52px;
                text-align: left;
                cursor: text;
                &.blue {
                  cursor: pointer;
                }
              }
              ul {
                font-size: 12px;
                color: #888;
                li {
                  line-height: 30px;
                  min-width: 150px;
                  text-align: left;
                  font-size: 12px;
                  float: left;
                  white-space: nowrap;
                  display: inline-block;
                  word-wrap: break-word;
                  word-break: normal;
                  cursor: text;
                  &.blue {
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
/*.go-center{*/
/*margin-left: 12px;*/
/*width: 90px;*/
/*background: #313131;*/
/*color: #c99f4f;*/
/*height: 34px;*/
/*line-height: 28px;*/
/*text-align: center;*/
/*font-weight: bold;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/base/Header.vue